var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incomedetails"},[_c('tablelist',{ref:"table",attrs:{"tableArray":_vm.tableArray,"defaultTable":_vm.defaultTable,"isPage":true,"total":_vm.total,"pageSize":_vm.params.page_size},on:{"currentMethod":_vm.currentMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }